import { Link } from "react-router-dom";
import { HOME } from "../services/consts";

function Error() {
    return(
        <div className="container error">
            <div className="errorin">
                <h1 className="error_text">ERROR</h1>
                <p className="error_desc">Check your internet connection<br/>..or go cry</p>
                <Link to={HOME} className="reload">Reload</Link>
            </div>
        </div>
    );
}

export default Error;